import type { StoreFrontDto } from '@b-stock/listing-api-client'

import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import { isMobileCategoryStorefront } from '../helpers/isMobileCategoryStorefront'
import { resolveStorefrontsForListings } from './resolveStorefrontsForListings'

/**
 * Classifies which of `listings` belong to a mobile-category storefront —
 * the signal buildDownloadableBidSheetCsv and validateBidSheetRows use to
 * decide whether a lot's device model may stand in for its listing title
 * (mobile rows only; model is a generic, category-unrestricted attribute,
 * so a non-mobile listing can carry one too without being a device listing).
 * `storefront` is the page's own storefront context, used as a shortcut the
 * same way fetchMobileManifestItems does; a batch spanning multiple
 * storefronts (e.g. the All Listings Page, or an uploaded sheet) instead
 * resolves each listing's own storefront via a bulk by-id lookup.
 */
export async function fetchMobileListingIds(
  accessToken: string | null,
  listings: CombinedListingSearchResult[],
  storefront: StoreFrontDto | undefined
): Promise<Set<string>> {
  if (listings.length === 0) return new Set()

  const storefrontsById = await resolveStorefrontsForListings(
    accessToken,
    listings,
    storefront
  )

  return new Set(
    listings
      .filter((listing) =>
        isMobileCategoryStorefront(storefrontsById[listing.storefrontId])
      )
      .map((listing) => listing.listingId)
  )
}
